import React from "react";
import {  DropdownSingle } from "oolib";
import mixpanel from "mixpanel-browser";

export const Sort = ({
    genCustomSelectComp,
    sortConfig,
    activeSort,
    setActiveSort,
    saveValueAsString,
    usedIn
  }) => (
    <DropdownSingle
      options={sortConfig}
      value={activeSort}
      onChange={(id, value) => {
        if(usedIn){
          mixpanel.track('Sort Selected', {
            Feature: usedIn,
            "Sort By": sortConfig.find(d => d.value === value)?.display
          })
        }
        
        setActiveSort(value)
      }}
      className="sortDropdown"
      popOutOfOverflowHiddenParent={true}
      alignDropdown={"right"}
      genCustomSelectComp={genCustomSelectComp}
      saveValueAsString={saveValueAsString}
    />
);